import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDHeadlineText, FDStack, FDTitleText,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import EstatePlanningProfileSubpageStepActionPicker
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/EstatePlanningProfileSubpage/EstatePlanningProfileSubpageStep/EstatePlanningProfileSubpageStepActionPicker/EstatePlanningProfileSubpageStepActionPicker';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  SecondaryActionButtonRel,
} from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';
import { dataAttrs, DataValueMap } from 'Helpers/Testing';
import { EstatePlanningManagementPageStepProgress } from './EstatePlanningManagementPageStepProgress';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDTitleText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => FDBodyText,
  }, overrideReadOnly);

export const EstatePlanningManagementPageStep = ({ stepResource, currStep, totalSteps }) => {
  const isMobile = useMobileLayout();
  return (
    <FDStack
      direction={'column'}
      spacing={isMobile ? 2 : 5}
      {...DataValueMap
        .init('estate-planning-management-page-step')
        .append(DataValueMap.keyMap.dataIndex, currStep)
        .build()}
    >
      <FDStack direction={'column'} spacing={isMobile ? 1 : 2}>
        <EstatePlanningManagementPageStepProgress
          currStep={currStep}
          totalSteps={totalSteps}
          stepResource={stepResource}
        />
        <FDHeadlineText value={'Next Steps'} />
        <MetaControl resource={stepResource} attrName={'description'} metaOverrideSet={metaOverrideSet} />
      </FDStack>
      <FDStack direction={'column'} spacing={2}>
        <EstatePlanningProfileSubpageStepActionPicker resource={stepResource} />
        {stepResource.withRelationship(fr.relationships.secondaryAction.name, (rel) => {
          return (<SecondaryActionButtonRel relationship={rel} {...dataAttrs('step-secondary-action-btn')} />);
        }, () => null)}
      </FDStack>
    </FDStack>
  );
};

EstatePlanningManagementPageStep.propTypes = {
  stepResource: PropTypes.object.isRequired,
  currStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};
